// Core services and utilities
export { createTelemetryService } from './telemetry';
export { createPixelService } from './pixel';
export { createReportingService } from './reporting';

// API client and error handling
export { apiClient, ApiError } from './api/client';
export {
  handleError,
  AppError,
  ValidationError,
  NetworkError,
  BusinessError
} from './utils/error-handling';

// Environment configuration
export { env } from './config/environment';

// Types
export * from './types';

// Logging. The class is shared with the other front ends; this app's own
// AppError above is a different, richer one (with Validation/Network/
// Business subclasses) and deliberately stays local.
export { Log } from '@ainova/core';

// Initialize services
import { createTelemetryService } from './telemetry';
import { createPixelService } from './pixel';
import { createReportingService } from './reporting';
import { env } from './config/environment';
import { Log } from '@ainova/core';

// Create global logger
export const logger = new Log('App');

// Log initialization
if (env.features.debugging) {
  logger.info('Application initializing', {
    environment: env.sentry.environment,
    apiUrl: env.apiBaseUrl,
    features: env.features
  });
}

// Export service instances
export const telemetry = createTelemetryService();
export const pixel = createPixelService();
export const reporting = createReportingService();
